// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"189":"3522952d","453":"1729a2d1"}[chunkId] + ".chunk.js";
};